import React from "react";
import classes from "./ProjectPreview.module.css";

function ProjectPreview({ project, onClick, isActive }) {
    return (
        <div className={`${classes.preview} ${isActive ? classes.active : ""}`} onClick={onClick}>
            <img src={project.image} alt={project.title} className={classes.image} />
            <h3 className={`${classes.title} ${isActive ? classes.active : ""}`}>{project.title}</h3>
            <div className={classes.tags}>
                {project.tags.map((tag, index) => (
                    <span key={index} className={classes.tag}>{tag}</span>
                ))}
            </div>
        </div>
    );
}

export default ProjectPreview;